import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import tokens from "../../utils/token";
import CurrentCart from "./CurrentCart";
import { useTheme } from "../../contexts/ThemeContext";
import "./ClientHeaderStyles.css";

const ClientHeader = ({ currentCommand, setCurrentCommand, displayCart = true, onSearchChange }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const { isDarkMode, toggleTheme } = useTheme();

  const [isMobile, setIsMobile] = useState(() => window.innerWidth <= 768);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  // Ne pas afficher le header sur les pages d'authentification
  const isAuthPage = location.pathname.includes('/client-auth');
  
  if (isAuthPage) {
    return null;
  }

  const handleLogout = async () => {
    await tokens.client_token.removeToken();
    window.location.href = '/client-auth';
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchValue(value);
    if (onSearchChange) {
      onSearchChange(value);
    }
  };

  const handleCheckout = () => {
    navigate('/client/checkout');
  };

  return (
    <header className="patricians-header">
      <div className="patricians-header-container">
        {/* Logo à gauche */}
        {
          !isMobile && (
            <div className="patricians-header-logo">
              <Link to="/shop" className="patricians-logo-link">
                <img 
                  src={isDarkMode ? "/patricians2.png" : "/patricians.png"} 
                  alt="Logo" 
                  className="patricians-logo-image"
                />
              </Link>
            </div>
          )
        }

        {/* Actions à droite */}
        <div className="patricians-header-actions">
          {/* Toggle Dark Mode */}
          <button 
            className="patricians-theme-toggle"
            onClick={toggleTheme}
            aria-label="Toggle dark mode"
            title={isDarkMode ? "Light mode" : "Dark mode"}
          >
            {isDarkMode ? '☀️' : '🌙'}
          </button>

          {/* Recherche */}
          <div className="patricians-search-box">
            <span className="patricians-search-icon">🔎</span>
            <input
              type="text"
              placeholder="Search"
              value={searchValue}
              onChange={handleSearchChange}
              className="patricians-search-input"
            />
          </div>

          {/* Panier */}
          {displayCart && (
            <CurrentCart currentCommand={currentCommand} setCurrentCommand={setCurrentCommand} />
          )}

          {
            !isMobile && (
              <>
                {/* Profile */}
                <Link 
                to="/client/profile"
                className="patricians-checkout-link"
                >
                  Profile
                </Link>

                {/* Log out */}
                <button 
                  onClick={handleLogout}
                  className="patricians-checkout-link patricians-logout-button"
                >
                  Log out
                </button>
              </>
            )
          }
        </div>
      </div>
    </header>
  );
};

export default ClientHeader;
